











import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "GrayBox",
  components: {
    Heading
  },
  props: {
    title: {
      type: String as PropType<Props["title"]>,
      required: true
    }
  }
});
